import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Card, CardBody,
  Container, Row, Col, Badge, Button,
} from "reactstrap";
import { businessesRepo } from "data/repositories/businessesRepo";
import EmptyState from "components/EmptyState";

import { CATEGORY_LABELS, categoryLabel } from "labels/tr";

export default function BusinessDetail() {
  const { id } = useParams();
  const [biz, setBiz] = useState(null);

  useEffect(() => {
    setBiz(businessesRepo.getById(id));
  }, [id]);

  if (!biz) {
    return (
      <>
        <div className="header bg-gradient-info pb-6 pt-5 pt-md-7" />
        <Container className="mt--6" fluid>
          <EmptyState title="İşletme bulunamadı" />
        </Container>
      </>
    );
  }

  return (
    <>
      <div className="header bg-gradient-info pb-6 pt-5 pt-md-7">
        <Container fluid>
          <h1 className="text-white mb-1">{biz.name}</h1>
          <p className="text-white opacity-8 mb-0">{categoryLabel(biz.category)}</p>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Card className="shadow mb-4">
          <CardBody>
            <Row>
              <Col md={8}>
                <h4>Açıklama</h4>
                <p className="text-muted">{biz.description}</p>

                {biz.location?.addressLine && (
                  <>
                    <h5>Adres</h5>
                    <p className="text-muted">{biz.location.addressLine}</p>
                  </>
                )}
                {biz.contact?.phone && (
                  <>
                    <h5>Telefon</h5>
                    <p className="text-muted">{biz.contact.phone}</p>
                  </>
                )}
              </Col>
              <Col md={4}>
                <Card className="bg-secondary shadow-sm">
                  <CardBody>
                    <div className="mb-2">
                      <Badge color="info" className="mr-1">{categoryLabel(biz.category)}</Badge>
                      <Badge color="light" className="text-dark">{biz.location?.provinceId || "-"}</Badge>
                    </div>
                    {biz.priceFromText && (
                      <p className="mb-2">
                        <i className="fas fa-lira-sign" /> {biz.priceFromText}
                      </p>
                    )}
                    <Button
                      color="primary"
                      block
                      tag={Link}
                      to={`/admin/bookings/new?businessId=${biz.id}&businessName=${encodeURIComponent(biz.name)}`}
                    >
                      Rezervasyon yap
                    </Button>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Button color="secondary" tag={Link} to="/admin/businesses">
          <i className="fas fa-arrow-left mr-1" /> Tüm işletmeler
        </Button>
      </Container>
    </>
  );
}
